import React from "react";
import "../../../plans.scss";

export default function PioneerPlan() {
  return (
    <div className="col s4 m4 l4 Enterprise">
      <div className="plan-card">
        <div className="tag-price">
          <h3>
            {" "}
            <span>Pioneer</span>
          </h3>
          <div className="row price-box">
            <h2>
              <span style={{ fontSize: "34px", color: "#447ce9" }}>
                $10.00{" "}
              </span>{" "}
              / month{" "}
            </h2>
          </div>
        </div>
        <p style={{ fontWeight: "500", color: "#989898" }}>
          Everything in Free +
        </p>

        <ul>
          <li>Access to all newly released features for free</li>
          <li>Access to all render shaders</li>
          <li>Enhanced interface</li>
          <li>Higher-res image exports</li>
          <li>500 image uploads</li>
          <li>Access to #feature-request discord</li>
        </ul>
        <div className="row buttons">
          <div className="col s12 m12  l12 ">
            <p
              style={{
                textAlign: "center",

                color: "#949494",
              }}
            >
              Limited time offer
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
